// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"456":"c608131d","842":"fa57d04f","979":"ad569cf2"}[chunkId] + ".js";
};